import type { FC } from 'react';
import { useLocation } from 'react-router';
import { useCurrentUser } from 'src/lib/customHooks/useCurrentUser';
import { MainHeader } from './MainHeader';
import { NavbarWithoutHeader } from './NavbarWithoutHeader';

export const Header: FC = () => {
  const { pathname } = useLocation();
  const currentUser = useCurrentUser();

  if (pathname.startsWith('/admin')) {
    return <MainHeader />;
  }

  if (pathname.startsWith('/safemap') && currentUser) {
    return <MainHeader />;
  }

  if (
    pathname.startsWith('/upload') ||
    pathname.startsWith('/tracker/') ||
    (pathname.startsWith('/app') && !pathname.includes('redeem_key'))
  ) {
    return <NavbarWithoutHeader />;
  }

  return null;
};
